import { render } from "./Order.vue?vue&type=template&id=2f3907d0"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=2f3907d0&lang=less"
script.render = render

export default script